import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { LocationStatusFilter } from "../Locations/Location";
import { PageHeader } from "@velocity-ehs/component-library";
import { LocationsTreeCard } from "./LocationsTreeCard";
import { useTranslation } from "react-i18next";
import classes from "../Locations/LocationsPage.module.scss";
import VerticalTabs from "../../sharedComponents/VerticalTabs";

const defaultStatusFilter: LocationStatusFilter[] = [];

const LocationsPageNew: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [statusFilter, setStatusFilter] =
    useState<LocationStatusFilter[]>(defaultStatusFilter);
  const handleAddChildLocationClick = (parentId: string) => {
    return history.push(`/location/${parentId}/add`);
  };
  const handleRowClick = (event: any) => {
    if (
      event.originalEvent.target.className.includes("p-button") ||
      event.originalEvent.target.className.includes("p-menuitem")
    ) {
      return;
    }
    return history.push(`/location/${event.node.id}/edit`);
  };

  const page = (
    <>
      <PageHeader
        title={t("universal_Locations")}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          { text: t("universal_Locations"), href: "" },
        ]}
      />
      <VerticalTabs
        tabs={[
          {
            content: (
              <div className={classes.locationsContent}>
                <LocationsTreeCard
                  statusFilter={statusFilter}
                  setStatusFilter={(e) => setStatusFilter(e.value)}
                  handleRowClick={handleRowClick}
                  handleAddChildLocationClick={handleAddChildLocationClick}
                />
              </div>
            ),
            title: t("universal_Locations"),
          },
        ]}
      />
    </>
  );

  return page;
};

export default LocationsPageNew;
